import React from 'react';

import { Dialog } from '@tencent/spaui';
import { connect } from 'react-redux';
import { store } from '../../store/Store';
import { GlobalStateAction } from '../../actions/GlobalStateAction';

const mapStateToProps = (state) => ({ ...state.global });

class Tips extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.tips && nextProps.tips.show) {
      this.setState({
        show: nextProps.tips.show,
        message: nextProps.tips.message,
        callBack: nextProps.tips.callBack,
        type: nextProps.tips.type,
        time: nextProps.tips.time,
      });
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose = (e) => {
    this.setState({ show: false });
    if (this.state.callBack != null) {
      this.state.callBack();
    }
    store.dispatch({
      type: GlobalStateAction.HIDE_TIPS,
    });
  };

  render() {
    const time = this.state.time ? this.state.time : 8000;
    return (
      <Dialog
        className="tipspop"
        show={this.state.show}
        time={time}
        timeCallback={this.handleClose}
        type="tip"
        iconType={this.state.type}
      >
        {this.state.message}
      </Dialog>
    );
  }
}

const ReduxTips = connect(mapStateToProps)(Tips);

export default ReduxTips;
